import { useMemo } from 'react';
import { Dropdown } from '@geberit/gdds';

// types
import type { SelectOption } from '@geberit/gdds/dist/esm/form/Dropdown/types/Dropdown.types';

// utils
import { useXy } from 'utils/hooks/use-xy';

type ProductDetailFiltersSelectViewProps = {
  currentValue: string;
  onSelectChange: (value: string) => void;
  disabled?: boolean;
  defaultValue?: string | null;
  options?: any[];
  checkOptionStatus?: (option: any) => boolean;
};

function ProductDetailFiltersSelectView({
  options,
  onSelectChange,
  currentValue = '',
  defaultValue = '',
  disabled = false,
  checkOptionStatus,
}: Readonly<ProductDetailFiltersSelectViewProps>) {
  const isXy = useXy();

  const dropdownItems = useMemo(() => {
    if (isXy) {
      const availableOptions = defaultValue
        ? [
          {
            id: defaultValue,
            value: '',
            text: defaultValue,
          }
        ]
        : [];
      options?.reduce((acc, option) => {
        acc.push({
          id: option,
          text: option,
          value: option,
          disabled: checkOptionStatus ? checkOptionStatus(option) : false,
        });
        return acc;
    }, availableOptions);

      return availableOptions;
    }

    return [];
  },
  [options, isXy]);

  if (isXy) {
    return (
      <Dropdown
        outlined
        name=""
        defaultValue={currentValue || ''}
        disabled={disabled}
        items={dropdownItems}
        onChange={(option) => onSelectChange((option as SelectOption).value)}
      />
    );
  }

  return (
    <div className={`gb-select ${disabled ? ' gb-select--disabled' : ''}`}>
      <div className="gb-select__value">{currentValue || defaultValue}</div>
      <select
        onChange={({ target: { value } }) => onSelectChange(value)}
        disabled={disabled}
        value={disabled ? (defaultValue ?? '') : currentValue}
      >
        <option value="">{defaultValue}</option>
        {!disabled &&
          options?.map((option) => (
            <option
              key={option}
              value={option}
              disabled={checkOptionStatus ? checkOptionStatus(option) : false}
            >
              {option}
            </option>
          ))}
      </select>
    </div>
  );
}

export default ProductDetailFiltersSelectView;
